/**
 * Converts a simple SVG React element (such as a Lucide icon) to an SVG string
 * without importing 'react-dom/server', saving 57+ KiB of unused JS in client bundles.
 */
export function reactElementToSvgString(element: any): string {
    if (!element) return '';
    if (typeof element === 'string' || typeof element === 'number') return String(element);

    let type = element.type;
    if (typeof type === 'object' && type !== null) {
        if (typeof type.render === 'function') {
            return reactElementToSvgString(type.render(element.props, null));
        }
        if (type.type) {
            return reactElementToSvgString({ ...element, type: type.type });
        }
    }
    if (typeof type === 'function') {
        try {
            return reactElementToSvgString(type(element.props));
        } catch {
            return '';
        }
    }

    if (typeof type !== 'string') return '';

    const props = element.props || {};
    const attrs: string[] = [];

    // Ensure root svg has xmlns for CSS background-image data URLs
    if (type === 'svg' && !props.xmlns) {
        attrs.push('xmlns="http://www.w3.org/2000/svg"');
    }

    Object.keys(props).forEach((key) => {
        if (key === 'children' || key === 'key' || key === 'ref') return;
        let value = props[key];
        if (value === null || value === undefined) return;
        
        // Convert React props like strokeWidth -> stroke-width, className -> class, but keep viewBox
        let attrName = key;
        if (key === 'className') attrName = 'class';
        else if (key === 'viewBox') attrName = 'viewBox';
        else attrName = key.replace(/([A-Z])/g, '-$1').toLowerCase();

        attrs.push(`${attrName}="${String(value).replace(/"/g, '&quot;')}"`);
    });

    const children = Array.isArray(props.children)
        ? props.children.map(reactElementToSvgString).join('')
        : props.children ? reactElementToSvgString(props.children) : '';

    return `<${type} ${attrs.join(' ')}>${children}</${type}>`;
}

